import Headline from '@allesauto/core/headline';
import { Colors, HeadlineVariation, theme } from '@allesauto/utils/consts';
import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';

import BoxPictureText, { BoxPictureTextProps } from './BoxPictureText';

interface BannerBoxPictureTextProps {
  _uid: string;
  component: string;
  headline: string;
  headlineColor: Colors;
  headlineFontSize: 'title' | 'headline2' | 'headline3' | 'headline4';
  text: string;
  background: Colors.WHITE | Colors.GREY;
  tiles: BoxPictureTextProps[];
}

const cssClasses = {
  container: 'grid grid-cols-24 py-[15px] md:py-40px  lg:py-60px',
  content: 'col-start-2 col-end-24',
  headlineContainer:
    'mb-30px lg:mb-[50px] grid grid-cols-1 lg:grid-cols-12 gap-[16px]',
  headline: 'col-span-4',
  text: 'col-span-6',
  tilesContainer: 'grid lg:grid-cols-3 grid-cols-1',
};

const BannerBoxPictureText = (props: BannerBoxPictureTextProps) => {
  const { headline, headlineColor, headlineFontSize, text, background, tiles } =
    props;
  return (
    <section
      className={clsx(cssClasses.container, theme[background].background)}
      {...sbEditable(props)}
    >
      <div className={cssClasses.content}>
        <div className={cssClasses.headlineContainer}>
          <Headline
            headlineText={headline}
            headlineColor={theme[headlineColor].text}
            headlineClassName={clsx(
              cssClasses.headline,
              headlineFontSize && `text-${headlineFontSize}`
            )}
            headlineTag={HeadlineVariation.H2}
          />
          <p className={clsx(cssClasses.text, theme[headlineColor].text)}>
            {text}
          </p>
        </div>
        <div className={cssClasses.tilesContainer}>
          {tiles.map((tile) => (
            <BoxPictureText
              {...tile}
              key={tile._uid}
              trackId="banner_box_picture_text_item_click"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BannerBoxPictureText;
